import api from './api';

export const getListCoupon = (params = {}) => {
  return api().get('/coupon', { params });
};

export const getListRsError = (params = {}) => {
  return api().get('/rs-error', { params });
};

export const getListCustomerType = (params = {}) => {
  return api().get('/customer-type', { params });
};

export const delCouponService = (list_id = []) => {
  return api().delete('/coupon', { data: { list_id } });
};

export const createCouponService = (values) => {
  return api().post(`/coupon`, values);
};

export const updateCouponService = (values) => {
  return api().put(`/coupon`, values);
};

export const getDetaiCouponService = (id) => {
  return api().get(`/coupon/${id}/detail`);
};

export const getListCouponService = (id) => {
  return api().get(`/coupon/${id}/detail/list-coupon`);
};

export const getpOptions = () => {
  return api().get(`/coupon/error-group/options`);
};

export const getCountAllCoupon = () => {
  return api().get(`/coupon/count-all`);
};
